module.exports = __webpack_public_path__ + "media/Images/background-graypattern-6025f2d2ba281759933a8c586739adea.svg";